import { render, staticRenderFns } from "./Turismo5Select.vue?vue&type=template&id=a7f8f954&scoped=true&"
import script from "./Turismo5Select.vue?vue&type=script&lang=js&"
export * from "./Turismo5Select.vue?vue&type=script&lang=js&"
import style0 from "./Turismo5Select.vue?vue&type=style&index=0&id=a7f8f954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f8f954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
